
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-e74af8ae!sass-loader?sourceMap!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./PrivacyTerms.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./PrivacyTerms.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-e74af8ae!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./PrivacyTerms.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/views/privacyTerms/PrivacyTerms.vue
// module id = 1221
// module chunks = 1